// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2lrDj","bigColWidth":"Table_bigColWidth__38Wq_","biggerColWidth":"Table_biggerColWidth__ZUS_w","row":"Table_row__ehFPq","col":"Table_col__FO5Wp"};